import { ISendingScheduleRepository } from '../../ports/ISendingScheduleRepository'
import { CreateSendingScheduleRequest } from '../../../shared/types/CreateSendingScheduleRequest'
import { SendingSchedule } from '../../../shared/types/SendingSchedule'

export class CreateSendingScheduleUseCase {
  constructor(private repo: ISendingScheduleRepository) {}
  execute(payload: CreateSendingScheduleRequest): Promise<SendingSchedule> {
    return this.repo.create(payload)
  }
}
